import { Vestiging } from "./vestiging.model";
import { Specialisatie } from "./specialisatie.model";

export class Member {
  id!: string;
  voornaam!: string;
  achternaam!: string;
  rol!: string;
  foto: string | undefined;
  vestigingen?: Vestiging[];
  beschrijving: string | undefined;
  specialisaties?: Specialisatie[];
  email!: string;
}
